var map = {
	"./Add_Kodansha.svg": 16667,
	"./Anime_Kodansha.svg": 32848,
	"./Art Book_Kodansha.svg": 37370,
	"./Books_Kodansha.svg": 15771,
	"./Data_Kodansha.svg": 53186,
	"./Deals_Kodansha.svg": 47161,
	"./Direction_Kodansha.svg": 79574,
	"./Direction_No_Border_Kodansha.svg": 85735,
	"./Document_Kodansha.svg": 76921,
	"./Events_Kodansha.svg": 36047,
	"./File_Kodansha.svg": 51801,
	"./Games_Kodansha.svg": 35060,
	"./Giveaway_Kodansha.svg": 16780,
	"./Level_Kodansha.svg": 56991,
	"./Live Action_Kodansha.svg": 94294,
	"./Location_Kodansha.svg": 91581,
	"./Magazine_Kodansha.svg": 45310,
	"./Mail_Kodansha.svg": 61422,
	"./Manga_Kodansha.svg": 62761,
	"./Map_Kodansha.svg": 47931,
	"./Men_Kodansha.svg": 62316,
	"./Music_Kodansha.svg": 92208,
	"./Novel_Kodansha.svg": 33060,
	"./Outdoors_Kodansha.svg": 74778,
	"./Photo_Kodansha.svg": 1824,
	"./Picture Book_Kodansha.svg": 61129,
	"./Pin_Kodansha.svg": 89018,
	"./Quote_Kodansha.svg": 46324,
	"./Reading Room_Kodansha.svg": 83422,
	"./Returns_Kodansha.svg": 16431,
	"./Sales_Kodansha.svg": 60851,
	"./Shipping_Kodansha.svg": 35813,
	"./Sport_Kodansha.svg": 59767,
	"./Stairs_Kodansha.svg": 22209,
	"./Survey_Kodansha.svg": 5859,
	"./Sweepstakes_Kodansha.svg": 29088,
	"./Weather_Kodansha.svg": 33355,
	"./Women_Kodansha.svg": 58433
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93202;